import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { Row, Col, Button, Label } from "reactstrap";
import * as Scroll from "react-scroll";
import StoreContext from "./../../../Store/Context";
import { MESSAGE_ICON } from "./../../Constants/SrcImages";
import {
  MESSAGE_CHAT_CONTAINER_TEACHER,
  validateTokenStorage,
} from "./../../Constants/Util";
import {
  getMessages,
  getMessagesTeacher,
  postMessages,
  postMessagesTeacher,
  getGradeTeacherMessages,
  getStudentListByGrade,
  getStudentListByTeacher,
  fetchtMessagesForum,
  fetchtMessagesForumT
} from "./../../Constants/Services";
import {
  IGrades,
  IMessage,
  IMessagePersonTeacher,
  IGradeCount,
} from "./../../Constants/Interfaces";
import "./../../../www/css/Chat.css";
import moment from "moment";
let scroll = Scroll.animateScroll;

interface IMessageState {
  dataPerson: IMessagePersonTeacher[];
  dataGrade: IGrades[];
  formGrade: IGrades;
  personForm: IMessagePersonTeacher;
  dataMessages: IMessage[];
  loading: boolean;
  formMessages: {
    msg_remitente: string;
    msg_destinatario: string;
    msg_desc: string;
    msg_time: string;
  };
  dataGradeCount: IGradeCount[];
  isOpenForum: boolean;
  isOpenMessage: boolean;
  isGradeSelected: boolean;
  isTeacher:boolean;
  count_t:string;
}

class MessagesTeacher extends Component<
  RouteComponentProps<{}>,
  IMessageState
> {
  static contextType = StoreContext;
  constructor(props: any) {
    super(props);
    this.state = {
      count_t:"",
      dataPerson: [],
      dataGradeCount: [],
      dataGrade: [],
      formGrade: {
        gr_id: "",
        gr_desc: "",
        gr_alias: "",
      },
      personForm: {
        per_id: "",
        per_name: "",
      },
      dataMessages: [],
      loading: false,
      formMessages: {
        msg_remitente: "",
        msg_destinatario: "",
        msg_desc: "",
        msg_time: "",
      },
      isOpenForum: false,
      isOpenMessage: false,
      isGradeSelected: false,
      isTeacher:false
    };
    this.fetchtGrade = this.fetchtGrade.bind(this);
    this.fetchtMessagesDestinatario = this.fetchtMessagesDestinatario.bind(
      this
    );
    this.fetchtMessagesDestinatarioTeacher = this.fetchtMessagesDestinatarioTeacher.bind(this);
    this.handlerSendMessage = this.handlerSendMessage.bind(this);
    this.fetchtMessages = this.fetchtMessages.bind(this);
    this.onChangeMessages = this.onChangeMessages.bind(this);
    this.setPerson = this.setPerson.bind(this);
    this.handleOpenMessage = this.handleOpenMessage.bind(this);
    this.handleOpenGradeSelected = this.handleOpenGradeSelected.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
    this.setPersonForum = this.setPersonForum.bind(this);
    this.getMessagesForum = this.getMessagesForum.bind(this);
    this.handlerSetTeacher = this.handlerSetTeacher.bind(this);
  }

  async fetchtGrade() {
    var response = await getGradeTeacherMessages(this.context.per_id);
    var count = response.count;
    var count_t = response.count_t[0].count;
    let hash = {};
    response = response.grade.filter((o) =>
      hash[o.gr_id] ? false : (hash[o.gr_id] = true)
    );

    response.sort(function (a, b) {
      return a.gr_id - b.gr_id;
    });

    this.setState({
      dataGrade: response,
      dataGradeCount: count,
      loading: false,
      isGradeSelected: false,
      isTeacher:false,
      count_t:count_t
    });
  }
  
  async fetchtMessagesDestinatarioTeacher() {

    const response = await getStudentListByTeacher(this.context.per_id);
    if (response.length > 0) {
      this.setState({ dataPerson: response, loading: false });
    } else {
      this.setState({ dataPerson: [], loading: false, isGradeSelected: true });
    }
  }

  async fetchtMessagesDestinatario(gr_id: string) {
    const response = await getStudentListByGrade(gr_id, this.context.per_id);

    if (response.length > 0) {
      this.setState({ dataPerson: response, loading: false });
    } else {
      this.setState({ dataPerson: [], loading: false, isGradeSelected: true});
    }
  }

  async fetchtMessages(per_id: string) {
    var num;
    if(Number(per_id)>Number(this.context.per_id)){
      num=per_id+"_"+this.context.per_id;
    }
    else{
      num=this.context.per_id+"_"+per_id;
    }

    if(this.state.isTeacher)
    {

      const response = await getMessagesTeacher(num,this.context.per_id);
      this.setState({ dataMessages: response, loading: false });
      scroll.scrollToBottom({
        containerId: "scrollContainer",
      });
      setTimeout(() => {
        // this.fetchtMessagesDestinatario(this.state.formGrade.gr_id);
      }, 1000);
    }
    else{
      const response = await getMessages(per_id + this.context.per_id,this.context.per_id);
      this.setState({ dataMessages: response, loading: true });
      scroll.scrollToBottom({
        containerId: "scrollContainer",
      });
      setTimeout(() => {
        this.fetchtMessagesDestinatario(this.state.formGrade.gr_id);
      }, 1000);
    }
  }

  componentDidMount() {
    if (validateTokenStorage()) {
      this.context.quitToken();
    }
    this.fetchtGrade();
  }

  handlerSendMessage() {
    const propsMsg = this.state.formMessages;
    const props = this.state.personForm;
    const propsdestinatario = this.state.personForm;
    var num;
    if(Number(this.state.personForm.per_id)>Number(this.context.per_id)){
      num=this.state.personForm.per_id+"_"+this.context.per_id;
    }
    else{
      num=this.context.per_id+"_"+this.state.personForm.per_id;
    }
    if (this.state.isOpenForum) {
      if(this.state.isTeacher){
        const body = {
          msg_num: this.context.per_id,
          msg_person: this.context.per_id,
          msg_destinatario: "",
          msg_desc: propsMsg.msg_desc,
          msg_time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          msg_foro: "1",
        };
        postMessagesTeacher(body);
        setTimeout(() => {
          this.getMessagesForum();
        }, 1000);
      }
      else{
        const body = {
          msg_num: this.state.formGrade.gr_id + this.context.per_id,
          msg_person: this.context.per_id,
          msg_desc: propsMsg.msg_desc,
          msg_destinatario: "",
          msg_time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          msg_foro: "1",
          msg_grade: this.state.formGrade.gr_id,
        };
        postMessages(body);
        setTimeout(() => {
          this.getMessagesForum();
        }, 1000);
      }
    } else {
      if(this.state.isTeacher){
        const body = {
          msg_num: num,
          msg_person: this.context.per_id,
          msg_desc: propsMsg.msg_desc,
          msg_destinatario: this.state.personForm.per_id,
          msg_time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          msg_foro: "0",
          msg_grade: this.state.formGrade.gr_id,
        };
    
        postMessagesTeacher(body);
        setTimeout(() => {
          this.fetchtMessages(propsdestinatario.per_id);
        }, 1000);
      }
      else{
        const body = {
          msg_num: props.per_id + this.context.per_id,
          msg_person: this.context.per_id,
          msg_destinatario: this.state.personForm.per_id,
          msg_desc: propsMsg.msg_desc,
          msg_time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          msg_foro: "0",
          msg_grade: this.state.formGrade.gr_id,
        };
        postMessages(body);
        setTimeout(() => {
          this.fetchtMessages(propsdestinatario.per_id);
        }, 1000);
      }

    }

    this.setState({
      loading: true,
      formMessages: {
        msg_remitente: "",
        msg_destinatario: "",
        msg_desc: "",
        msg_time: "",
      },
    });
  }

  setPerson({ per_id, per_name }) {
    this.setState((prevState) => ({
      personForm: {
        per_id,
        per_name,
      },
      isOpenForum: false,
      isOpenMessage: true,
    }));
    this.fetchtMessages(per_id);
  }

  handlerSetGrade(gr_id: string, gr_desc: string, gr_alias: string) {
    this.setState({
      formGrade: {
        gr_id,
        gr_desc,
        gr_alias,
      },
      isOpenMessage: false,
      isGradeSelected: true,
    });
    this.fetchtMessagesDestinatario(gr_id);
  }

  handlerSetTeacher() {
    this.setState({
      isOpenMessage: false,
      isGradeSelected: true,
      isTeacher:true
    });
    this.fetchtMessagesDestinatarioTeacher();
  }

  onChangeMessages(e: any) {
    this.setState({
      formMessages: {
        ...this.state.formMessages,
        [e.target.name]: e.target.value,
      },
    });
  }

  rechargeData() {
    const propsF = this.state;
    const props = this.state.personForm;
if(propsF.isOpenForum){
  this.setState({ loading: true });
  setTimeout(() => {
    this.getMessagesForum();
  }, 1000);
}
else{
  this.setState({ loading: true });
  setTimeout(() => {
    this.fetchtMessages(props.per_id);
  }, 1000);
}
  }

  handleOpenMessage() {
    this.setState({
      dataMessages: [],
      personForm: {
        per_id: "",
        per_name: "",
      },
      isOpenMessage: false,
    });
  }

  handleOpenGradeSelected() {
    this.fetchtGrade();
    this.setState({
      isGradeSelected: false,
      dataMessages: [],
      personForm: {
        per_id: "",
        per_name: "",
      },
    });

  }

  async getMessagesForum() {
    if (validateTokenStorage()) {
      this.context.quitToken();
    }
    if(this.state.isTeacher){
      const response = await fetchtMessagesForumT();
      this.setState({ dataMessages: response, loading: false });
      scroll.scrollToBottom({
        containerId: "scrollContainer",
      });
    }
    else{
      const response = await fetchtMessagesForum(
        this.state.formGrade.gr_id + this.context.per_id
      );
      this.setState({ dataMessages: response, loading: false });
      scroll.scrollToBottom({
        containerId: "scrollContainer",
      });
    }
  }

  setPersonForum() {
    this.getMessagesForum();
    this.setState({
      personForm: {
        per_id: "",
        per_name:
          "FORO DEL " +
          this.state.formGrade.gr_desc +
          " " +
          this.state.formGrade.gr_alias,
      },
      isOpenForum: true,
      isOpenMessage: true,
    });
  }
  render() {
    const props = this.state;

    return (
      <React.Fragment>
        <Row>
          {props.isGradeSelected ? (
            <Col xs={12}>
              <MESSAGE_CHAT_CONTAINER_TEACHER
                per_id={this.context.per_id}
                props={props}
                handlerSendMessage={this.handlerSendMessage}
                onChangeMessage={this.onChangeMessages}
                setPerson={this.setPerson}
                setPersonForum={this.setPersonForum}
                isOpenMessage={props.isOpenMessage}
                isGradeSelected={props.isGradeSelected}
                handlerGoback={this.handleOpenMessage}
                handlerGobackToGrade={this.handleOpenGradeSelected}
                reload={this.rechargeData}
              />
            </Col>
          ) : (
            <React.Fragment>
              <Col xs={12} className="text-center mb-2">
                <h5 className="font-weight-bold">Mensajes</h5>
              </Col>
              {props.dataGrade.length > 0 ? (
                <Col xs={12}>
                  <Row>
                    {props.dataGrade.map((data, i) => (
                      <Col xs={6} sm={4} key={data.gr_id} className="mb-1">
                        <Button
                          className="mt-2 mb-2 w-100 box-h-90px info label-area-desc-bold"
                          onClick={() =>
                            this.handlerSetGrade(
                              data.gr_id,
                              data.gr_desc,
                              data.gr_alias
                            )
                          }
                        >
                          {`${data.gr_desc.toUpperCase()} ${data.gr_alias.toUpperCase()}`}
                          {props.dataGradeCount.find(function (item) {
                            if (item.msg_grade !== null) {
                              if (item.msg_grade.toLowerCase() === data.gr_id)
                                return true;
                            }
                            return null
                          }) ? (
                            <img
                              src={MESSAGE_ICON}
                              alt=""
                              className="img-position"
                            />
                          ) : null}
                        </Button>
                      </Col>
                    ))}
                    {
                      <Col xs={6} sm={4} className="mb-1">
                      <Button
                        className="mt-2 mb-2 w-100 box-h-90px ok label-area-desc-bold"
                        onClick={() =>
                          this.handlerSetTeacher()
                        }
                      >
                        SALA DE PROFESORES
                          {
                            Number(props.count_t) >0?             <img
                            src={MESSAGE_ICON}
                            alt=""
                            className="img-position"
                          />:null
                          }
                      
                      </Button>
                    </Col> 
                    }
                  </Row>
                </Col>
              ) : (
                <Col xs={12} className="text-center">
                  <Label className="font-weight-bold result-none">
                    Sin Resultados
                  </Label>
                </Col>
              )}
            </React.Fragment>
          )}
        </Row>
      </React.Fragment>
    );
  }
}
export default MessagesTeacher;
